import Button from "@mui/material/Button";
import Testo from "../elementi/Testo";
import { monFetch } from "../inc/inc";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";

const Comp = (props) => {

  let id = props.id;
  let idSezione = props.idSezione;

  const [nome, setNome] = useState("");
  const [descrizione, setDescrizione] = useState("");

  async function querySottosezione(id) {
    const res = await monFetch("/subsectionGet", {
      id: id,
    });
    // console.log(res);
    const subsezione = res.subsection;
    setNome(subsezione.name);
    setDescrizione(subsezione.description);
  }

  async function salvaSottosezione(e) {
    e.preventDefault();

    // console.log(password);
    // return
    const res = await monFetch("/subsectionSet", {
      id: id,
      section_id: idSezione,
      name: nome,
      description: descrizione,
    });
    // console.log(res);
    if (res.success) {
      props.setModificaSottosezione(false);
      props.querySottosezioni();
      // if (res.id) {
      //   window.location.href = process.env.PUBLIC_URL+"/sottosezione/" + res.id;
      // } else {
      //   window.location.href = process.env.PUBLIC_URL+"/sezione/" + res.subsection[0].section_id;
      // }
    }
  }

  useEffect(() => {
    if (id) {
      querySottosezione(id);
    } else {
      setNome("");
      setDescrizione("");
    }
  }, [id]);

  return (
    <>
      <form onSubmit={(e) => salvaSottosezione(e)}>
        <Grid container spacing={2}>
          <Grid item sm={6} xs={12}>
            <Testo
              required
              label="Nome"
              value={nome}
              onChange={(e) => {
                setNome(e.target.value);
              }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <Testo
              // required
              label="Descrizione"
              value={descrizione || ""}
              onChange={(e) => {
                setDescrizione(e.target.value);
              }}
            />
          </Grid>

          <Grid item sm={12} xs={12}>
            <div className="flexSpaceBetween">
              <Button
                className="buttonIndietro"
                onClick={() => {
                  props.setModificaSottosezione(false);
                }}
                variant="contained"
              >
                Annulla
              </Button>
              <Button className="buttonSalva" type="submit" variant="contained">
                Salva
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default Comp;
